import { useRef, useEffect, useState } from "react";
import { motion, useScroll, useTransform, useSpring } from "framer-motion";
import { WORK } from "../../data/content";

function WorkCard({ w, i, count, progress }) {
  const center = count > 1 ? i / (count - 1) : 0.5;
  const win = 0.28;
  const scale = useTransform(progress, [center - win, center, center + win], [0.9, 1.03, 0.9]);
  const imgScale = useTransform(progress, [center - win, center, center + win], [1.0, 1.14, 1.0]);

  return (
    <motion.div
      style={{ scale }}
      data-testid={`work-card-${i}`}
      className="relative w-[80vw] md:w-[46vw] shrink-0 rounded-3xl overflow-hidden border border-border"
    >
      <div className="overflow-hidden h-[56vh]">
        <motion.img style={{ scale: imgScale }} src={w.image} alt={w.title} className="w-full h-full object-cover" />
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-background via-background/30 to-transparent" />
      <div className="absolute bottom-0 p-8">
        <span className="font-mono-x text-xs tracking-[0.25em] text-primary">{w.tag}</span>
        <h3 className="mt-3 font-heading font-bold text-2xl md:text-3xl max-w-md">{w.title}</h3>
        <p className="mt-2 text-primary font-semibold">{w.metric}</p>
      </div>
    </motion.div>
  );
}

export default function Portfolio() {
  const targetRef = useRef(null);
  const trackRef = useRef(null);
  const [distance, setDistance] = useState(0);

  const { scrollYProgress } = useScroll({ target: targetRef, offset: ["start start", "end end"] });
  // spring-smoothed progress → buttery horizontal travel + zoom
  const progress = useSpring(scrollYProgress, { stiffness: 140, damping: 30, mass: 0.4 });
  const x = useTransform(progress, [0, 1], [0, -distance]);

  useEffect(() => {
    const measure = () => {
      const track = trackRef.current;
      if (!track) return;
      setDistance(Math.max(0, track.scrollWidth - window.innerWidth));
    };
    measure();
    const t = setTimeout(measure, 400);
    window.addEventListener("resize", measure);
    return () => { window.removeEventListener("resize", measure); clearTimeout(t); };
  }, []);

  const vw = typeof window !== "undefined" ? window.innerWidth : 1;
  const heightVh = 100 + (distance / vw) * 90;
  const count = WORK.length;

  return (
    <section
      id="work"
      data-testid="portfolio-section"
      ref={targetRef}
      className="relative"
      style={{ height: `${heightVh}vh` }}
    >
      <div className="sticky top-0 h-screen flex flex-col justify-center overflow-hidden">
        <div className="px-6 md:px-10 max-w-7xl mx-auto w-full mb-10">
          <span className="font-mono-x text-primary text-xs tracking-[0.35em]">/ 04 — SELECTED WORK</span>
          <h2 className="mt-4 font-heading font-extrabold tracking-tighter text-4xl md:text-5xl">Freight in the field</h2>
        </div>
        <motion.div ref={trackRef} style={{ x }} className="flex gap-8 pl-6 md:pl-10 pr-6 md:pr-10 w-max">
          {WORK.map((w, i) => (
            <WorkCard key={i} w={w} i={i} count={count} progress={progress} />
          ))}
        </motion.div>
      </div>
    </section>
  );
}
